// extracted by mini-css-extract-plugin
export default {"DeviceInformation":"DeviceInformation_DeviceInformation__Oh-sD","isMobile":"DeviceInformation_isMobile__hlKyL","usageGraph":"DeviceInformation_usageGraph__rkfCj"};